/*
 * Goloka V3 — the cart opens only when the shopper asks (cart icon, floating
 * pill). Adding a product no longer opens it: the floating pill confirms the
 * add instead (first add of the visit expands it into an "added" tray), so
 * shopping several items is never interrupted. Dawn's CartDrawer still renders
 * the new contents in the background, so the tray is current when opened.
 */
(function () {
  function patch() {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.prototype.__v3Patched) return;
    var render = CD.prototype.renderContents;
    CD.prototype.renderContents = function (state) {
      var self = this, open = this.open;
      this.open = function () {};              // swallow Dawn's auto-open after add
      render.call(this, state);
      setTimeout(function () { self.open = open; }, 0); // queued after Dawn's own open timer
    };
    CD.prototype.__v3Patched = true;
  }
  if (customElements.get('cart-drawer')) patch();
  else customElements.whenDefined('cart-drawer').then(patch);

  // Let CSS know when the tray is open (hides the pill underneath it).
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var sync = function () { document.documentElement.classList.toggle('v3-cart-open', d.classList.contains('active')); };
    // Esc closes the tray wherever focus is (Dawn only listens inside the drawer).
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('active')) d.close(); });
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
